// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2023 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import LinkPresentationPropsDefault from "@insite/mobius/Link/presentationProps";
import { xBaseTheme } from "@keller/XDL/types";
import { color, getSystemColor } from "@keller/XDL/Utilities";
import { css } from "styled-components";

export default {
    defaultProps: {
        ...LinkPresentationPropsDefault,
        color: "text.link",
        hoverStyle: {
            color: getSystemColor("common.ui1"),
        },
        css: css`
            &:visited {
                color: ${color("common.ui2")};
            }
        `,
    },
} as xBaseTheme["link"];
